
export const SET_JOB_STATUS = 'update_selected_status';

export const setJobStatus = value => { return {type: SET_JOB_STATUS, payload: value}; };